export {default as IncentiveTripBanner} from './IncentiveTripBanner.connect';
